import React from 'react';
import './index.scss';

import {connect} from 'react-redux'

function Cursor(props) {
  return props.isMobile ? null : (
    <div id="cursor" className={`${!props.show ? 'hide' : ''} ${props.active ? 'active' : ''} ${props.isFrontpage && !props.menuIsShowing ? 'front' : ''}` } style={{transform: `translate3d(${props.position.x}px, ${props.position.y}px, 0px)`}}>
    	<div className="display pointer"/>
    	<div className="link pointer">
    		<div className="arrow"/>
    	</div>
      <div className="scroll pointer" style={{transform: `rotateZ(${props.rotation}deg)`}}>
        <div className="arrow"/>
      </div>
    </div>
  );
}


export default connect((state) => ({
	position: state.Cursor.position,
	active: state.Cursor.active,
  show: state.Cursor.show,
  rotation: state.Cursor.rotation,
  isFrontpage: state.App.pagesToShow[0] ? state.App.pagesToShow[0].component === 'Frontpage' ? true : false : null,
  menuIsShowing: state.App.menuIsShowing,
  isMobile: state.Device.isMobile
}))(Cursor);
